module.exports = __webpack_public_path__ + "img/23.bd9f93ae.jpg";